type Props = {
    onClick: () => void;
}

export const StartDiscussionPop = ({ onClick }: Props) => {
    return (
        <div className="community-start-pop">
            <button onClick={onClick}>
                Start Discussion
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="4" viewBox="0 0 14 4" fill="none">
                    <path d="M8.5 0.378906L12 3.38306H0" stroke="white"/>
                </svg>
            </button>
        </div>
    )
}